import React, { useEffect, useState } from 'react';
import { BaseLayerView } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { convertImageToWebp } from '@/utils/file-kit';
import { type ITextLayerProps } from '@/version-types';
import { type TextLayerProps } from '../types';
import { getBackgroundStyle, getFlipStyle } from '../utils';
import './screenshot.less';

type Props = TextLayerProps;

/**
 * Screenshot 用于渲染文字图层截图（图片快照）
 *
 * 使用场景：
 *
 * - 非 navigator 场景下，用于舞台变形文字渲染（初始）
 */

const Screenshot: React.FC<Props> = ({ isNavigator, layer }) => {
    const { opacity, __isOnTextEditing: isOnTextEditing } = layer;
    const layerData = layer.data as ITextLayerProps;
    const { screenshotUrl } = layerData;

    const backgroundStyle = getBackgroundStyle(layer);

    const flipStyle = (() => {
        if (isOnTextEditing) return {};

        return getFlipStyle(layer);
    })();

    const [imageURL, setImageURL] = useState('');

    const loadImage = async () => {
        if (!screenshotUrl) {
            setImageURL('');
            return;
        }

        const url = base64Kit.getLocalUrl(screenshotUrl) as string;
        if (url) setImageURL(convertImageToWebp(url));
    };

    useEffect(() => {
        loadImage();
    }, [screenshotUrl]);

    return (
        <BaseLayerView layer={layer} isNavigator={isNavigator}>
            {!isOnTextEditing && imageURL ? (
                <div
                    style={{
                        opacity,
                        width: '100%',
                        height: '100%',
                        ...backgroundStyle,
                        ...flipStyle,
                    }}
                    className="text-layer-screenshot"
                >
                    <img src={imageURL} alt="" />
                </div>
            ) : null}
        </BaseLayerView>
    );
};

export default Screenshot;
